import { cardAt, isFieldZone } from './_shared';

/**
 * **効果の発動**（Issue #589）。`field` ＝ 場のカードの発動 / `elsewhere` ＝ 手札・墓地・除外・デッキからの発動。
 * 事実: `zone`（発動した場所。`triggerZone` で補う）/ `card`（そのカードの表裏・守備）。場所が無ければ null
 */
export const VARIANTS = Object.freeze([
  { name: 'field', label: '場のカードの発動' },
  { name: 'elsewhere', label: '手札・墓地・除外・デッキからの発動' },
]);

export default Object.freeze({
  event: 'chaining',
  variants: VARIANTS,
  classify({ payload, board }) {
    const zone = payload?.zone ?? payload?.triggerZone ?? null;
    if (!zone) return null;
    const c = cardAt(board, payload.uid, zone);
    return {
      ...payload,
      variant: isFieldZone(zone) ? 'field' : 'elsewhere',
      zone,
      card: { code: c?.code ?? payload.code ?? null, faceUp: c ? Boolean(c.faceUp) : true, defense: Boolean(c?.defense) },
    };
  },
});
